export default __webpack_public_path__ + "static/media/signin1.3eaf8d9b.png";